import { render, staticRenderFns } from "./ExchangeWarning.vue?vue&type=template&id=1b8ec198&scoped=true&"
import script from "./ExchangeWarning.vue?vue&type=script&lang=js&"
export * from "./ExchangeWarning.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeWarning.vue?vue&type=style&index=0&id=1b8ec198&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ec198",
  null
  
)

export default component.exports